module.exports = __webpack_public_path__ + "img/iron-nugget.fe71868e.png";